import { APIClient } from "api/api_helper";
import { SUBJECTCHECKIN_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";

const api = new APIClient();

export const subjectCheckinService = {
  getSelectAllData: (payload: any) => {
    return api.create(SUBJECTCHECKIN_API.SUBJECTCHECKIN + "SelectAll", {
      ...payload,
    });
  },

  getSelectData: (payload: any) => {
    return api.create(SUBJECTCHECKIN_API.SUBJECTCHECKIN + "Select", {
      ...payload,
    });
  },

  updateData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(SUBJECTCHECKIN_API.SUBJECTCHECKIN + "Update", {
      ...payload,
      updatedby: user.userid,
    });
  },

  deleteData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(SUBJECTCHECKIN_API.SUBJECTCHECKIN + "Delete", {
      ...payload,
      updatereason: payload.updatereason,
      updatedby: user.userid,
    });
  },
};
